import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import {DataGridProps} from "../../components/DataGrid/types";
import {DataGrid} from "../../components";


export const VoucherDataGrid = ({
  data,
  sizePerPage,
  page,
  count,
  onTableChange,
  onFilter,
}:Omit<DataGridProps, "columns">) => {
  const columns = [
    {
      dataField: 'reference_number',
      text: 'Reference Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldKey: 'reference_number',
          searchFieldType: 'text',
    },
    {
      dataField: 'cash',
      text: 'Cash',
      type: 'string',
      formatter: components.CellTextFormatter,
    },
    {
      dataField: 'cc',
      text: 'CC',
      type: 'string',
      searchFieldType: 'text',
    },
    {
      dataField: 'cheque',
      text: 'Cheque',
      type: 'string',
      searchFieldType: 'text',
    },
    {
      dataField: 'online_payment',
      text: 'Online Payment',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },


    {
      dataField: 'created_at',
      text: 'Created On',
      type: 'string',
      formatter: components.CellDateTimeFormatter,
      searchFieldType: 'date',
    },
          {
      dataField: 'url',
      text: 'Change Log',
      formatter: components.ChangeLogFormatter,
    },
  ]
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Vouchers</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-end" xs={6}>
            <components.Slider
              size="sm"
              sliderWidth={"20vw"}
              title={components.ICONS.SEARCH}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-1"> Tokens</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <DataGrid
          data={data || []}
          sizePerPage={sizePerPage || 10}
          page={page}
          columns={columns}
          count={count || 0}
          onTableChange={onTableChange}
          onFilter={onFilter}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
